import {
  allowMemberUseEvalForm,
  checkIsDollarProduct,
} from 'utils/checkIsOwner';

export const checkExpiryDateForCertification = (ownerId) => {
  return checkIsDollarProduct(ownerId) || allowMemberUseEvalForm(ownerId);
};
